import GlossaryBox from './GlossaryBox'

export default GlossaryBox;